import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('fr-FR', {
    day: '2-digit',
    month: 'long',
    year: 'numeric'
  }).format(date);
}

export function formatDateShort(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return new Intl.DateTimeFormat('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }).format(date);
}

export function formatCurrency(amount) {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR'
  }).format(amount || 0);
}

export function getStatusColor(status) {
  const colors = {
    'en_attente': 'status-pending',
    'approuve': 'status-approved',
    'refuse': 'status-rejected',
    'paye': 'status-approved',
    'a_confirmer': 'status-pending',
    'actif': 'status-active',
    'inactif': 'status-inactive',
    'planifie': 'status-pending',
    'realise': 'status-approved',
    'annule': 'status-rejected'
  };
  return colors[status] || 'status-pending';
}

export function getStatusLabel(status) {
  const labels = {
    'en_attente': 'En attente',
    'approuve': 'Approuvé',
    'refuse': 'Refusé',
    'paye': 'Payé',
    'a_confirmer': 'À confirmer',
    'actif': 'Actif',
    'inactif': 'Inactif',
    'planifie': 'Planifié',
    'realise': 'Réalisé',
    'annule': 'Annulé'
  };
  return labels[status] || status;
}
